
import { Component, Vue } from 'vue-property-decorator';
import { projectListQuery, projectListCommon, queryRate } from '@/api/finance.js';
import { listTableColumns, statusSummaryMap, dateString, currencyMap, permil } from '@/utils/finance';
import authConfig from '@/components/finance/authConfig.vue';
import moment from 'moment';
import downloadStreamFile from '@/assets/js/downloadStreamFile';
import { mapGetters } from 'vuex';

interface SearchParams {
  projectPeopleId: number | undefined;
  financePeopleId: number | undefined;
  legalPeopleId: number | undefined;
  projectStatus: number | undefined;
  searchName: string;
  page: number;
  pageSize: number;
}

interface PeopleInfo {
  id: number;
  name: string;
}

@Component({
  components: { authConfig },
  computed: { ...mapGetters(['userInfo']) }
})
class List extends Vue {
  searchParams: SearchParams = {
    projectPeopleId: undefined,
    financePeopleId: undefined,
    legalPeopleId: undefined,
    projectStatus: undefined,
    searchName: '',
    page: 1,
    pageSize: 20
  };
  projectPeopleList: PeopleInfo[] = [];
  financePeopleList: PeopleInfo[] = [];
  legalPeopleList: PeopleInfo[] = [];
  tableColumns = listTableColumns;
  dataList: object[] = [];
  total: number = 0;
  authProject: any = null;
  authConfigVisible = false;
  rate: number = 0;
  updateAt: number = 0;
  showModal: boolean = false;
  startDate: string = '';
  endDate: string = '';
  userInfo: any;

  async mounted() {
    this.fetchPeoList();
    this.fetchCompanyList();
    this.getRate();
  }

  async fetchPeoList() {
    projectListCommon().then(res => {
      let {
        data: { projectPeopleList = [], financePeopleList = [], legalPeopleList = [] }
      } = res;
      this.projectPeopleList = projectPeopleList.filter(item => item.name);
      this.financePeopleList = financePeopleList.filter(item => item.name);
      this.legalPeopleList = legalPeopleList.filter(item => item.name);
    });
  }

  async fetchCompanyList() {
    try {
      let res = await projectListQuery(this.searchParams);
      let { data = {} } = res || {};
      let { list = [], total } = data;
      list.forEach(_ => (_.financePeopleName = (_.financeUsers || []).map(user => user.userName).join(',')));
      this.dataList = list;
      this.total = total;
    } catch (e) {}
  }

  async getRate() {
    try {
      let res = await queryRate();
      if (res.code === 200) {
        this.rate = res.data.rate;
        this.updateAt = res.data.updateAt;
      }
    } catch (e) {
      console.log(e);
    }
  }

  selectChange(key) {
    return val => {
      this.searchParams[key] = val;
      this.searchParams.page = 1;
      this.fetchCompanyList();
    };
  }

  inputSearch(val) {
    this.searchParams.searchName = val;
    this.searchParams.page = 1;
    this.fetchCompanyList();
  }

  openExportModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
    this.endDate = '';
    this.startDate = '';
  }

  async exportReport() {
    try {
      // let res = await ;
      let date = moment(new Date()).format('YYYYMMDD');
      const { id } = this.userInfo || {};
      let data = {
        userId: id,
        startDate: this.startDate,
        endDate: this.endDate
      };
      await downloadStreamFile('/dataService/reportForm/middlePageData/financeDownload', data, `交易数据中间页_${date}`);
      this.closeModal();
    } catch (err) {
      console.log(err);
      this.closeModal();
    }
  }

  goDetail(projectId) {
    window.open(`/finance/middlePage/detail?projectId=${projectId}`);
  }

  pageChange(e) {
    let { current } = e;
    this.searchParams.page = current;
    this.fetchCompanyList();
  }
  auth(project) {
    this.authProject = project;
    this.authConfigVisible = true;
  }

  hideAuthConfig() {
    this.authConfigVisible = false;
  }

  startOnChange(date, dateString) {
    this.startDate = date ? moment(date).format('YYYYMMDD') : '';
  }

  onChange(date, dateString) {
    this.endDate = date ? moment(date).format('YYYYMMDD') : '';
  }

  render() {
    let {
      tableColumns,
      dataList,
      projectPeopleList,
      financePeopleList,
      legalPeopleList,
      selectChange,
      inputSearch,
      goDetail,
      total,
      pageChange,
      auth,
      authConfigVisible,
      hideAuthConfig,
      authProject,
      fetchCompanyList,
      searchParams,
      rate,
      updateAt,
      exportReport,
      openExportModal,
      closeModal,
      startOnChange,
      onChange
    } = this;

    let statusList = [1, 2, 3, 4, 5, 6].map(id => ({ name: statusSummaryMap[id], id }));
    let selectList = [
      {
        key: 'projectPeopleId',
        list: projectPeopleList,
        name: '项目DL(天池)',
        allowClear: true
      },
      {
        key: 'financePeopleId',
        list: financePeopleList,
        name: '财务负责人',
        allowClear: true
      },
      {
        key: 'legalPeopleId',
        list: legalPeopleList,
        name: '法务负责人',
        allowClear: true
      },
      {
        key: 'logicCompanyStatus',
        list: statusList,
        name: '项目状态',
        allowClear: true
      }
    ];
    return (
      <div>
        <a-breadcrumb>
          <a-breadcrumb-item>公允价值表</a-breadcrumb-item>
          <a-breadcrumb-item>财务-交易数据中间页</a-breadcrumb-item>
        </a-breadcrumb>
        <a-row class="search-bar">
          {selectList.map(selectItem => (
            <a-col span="4">
              <a-select
                placeholder={selectItem.name}
                onChange={selectChange(selectItem.key)}
                class="select"
                allowClear={selectItem.allowClear}
                value={searchParams[selectItem.key]}
              >
                {selectItem.list.map(item => (
                  <a-select-option value={item.id}>{item.name}</a-select-option>
                ))}
              </a-select>
            </a-col>
          ))}
          <a-col span="8" class="search-container">
            <a-input-search placeholder="搜索项目简称/名称" onSearch={inputSearch} class="input-search" />
            <div class="rate">
              汇率: {rate}
              <span class="gap-10"></span>
              更新日期: {moment(updateAt).format('YYYY-MM-DD')}
            </div>
          </a-col>
        </a-row>
        <div class="export-btn">
          <a-button data-ga-id="北冥-中间页列表-导出" type="primary" onClick={openExportModal}>
            导出
          </a-button>
        </div>
        <div>
          <a-table
            columns={tableColumns}
            data-source={dataList}
            bordered
            scroll={{ x: true }}
            scopedSlots={{
              projectStatus: projectStatus => <span class={projectStatus !== 1 ? 'warn' : ''}>{statusSummaryMap[projectStatus] || ''}</span>,
              action: project => (
                <div class="btns">
                  <a-button data-ga-id="北冥-中间页列表-点击进入" size="small" type="primary" onClick={goDetail.bind(this, project.projectId)}>
                    进入
                  </a-button>
                  {project.canAuth ? (
                    <a-button data-ga-id="北冥-中间页列表-点击权限" size="small" type="primary" onClick={auth.bind(this, project)}>
                      权限
                    </a-button>
                  ) : (
                    ''
                  )}
                </div>
              ),
              auditDate: auditDate => <span>{auditDate ? '截止' + dateString(auditDate) + '前' : ' '}</span>,
              lastModifyTime: timeString => dateString(timeString),
              cost: row => (
                <div class="cost">
                  <span>合计(USD)</span> {permil(row.costAll)}
                  <br></br>
                  <span>CNY</span> {permil(row.costCny)}
                  <br></br>
                  <span>USD</span> {permil(row.costUsd)}
                </div>
              ),
              moic: row => (
                <div class="moic">
                  <span>合计</span> {permil(row.moicAll, 2, true)}
                  <br></br>
                  <span>CNY</span> {permil(row.moicCny, 2, true)}
                  <br></br>
                  <span>USD</span> {permil(row.moicUsd, 2, true)}
                </div>
              )
              // currency: currency => currencyMap[currency]
            }}
            pagination={{
              total,
              current: this.searchParams.page,
              pageSize: this.searchParams.pageSize
            }}
            onChange={pageChange}
          />
        </div>
        {authConfigVisible ? (
          <auth-config visible={this.authConfigVisible} onHide={hideAuthConfig} onRefresh={fetchCompanyList} project={authProject}></auth-config>
        ) : (
          ''
        )}
        <div>
          {this.showModal ? (
            <a-modal title="交易数据中间页批量导出" visible="true" onOk={exportReport} onCancel={closeModal}>
              <div class="date-picker">
                <a-date-picker size="small" onChange={startOnChange} placeholder="开始日期" />
                <div class="margin-date">~</div>
                <a-date-picker size="small" onChange={onChange} placeholder="结束日期" />
              </div>
            </a-modal>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    );
  }
}
export default List;
